import { colors } from '@cimpress/react-components';

const LineBreak = () => <hr style={{ border: `1px solid ${colors.platinum}` }} />;

export default LineBreak;
